import React from 'react';
import PropTypes from 'prop-types';

import MaterialSwitch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { Field } from 'redux-form';
import { onClickWrapper } from '../../../utils/ui';

class Switch extends React.Component {
  static renderSwitch = ({
    className,
    checked,
    color,
    id,
    onChange,
    label,
    input,
    ...props
  }) =>
    label ? (
      <FormControlLabel
        control={
          <MaterialSwitch
            {...props}
            {...{ checked, id, color }}
            onChange={onClickWrapper(id, onChange)}
            {...input}
          />
        }
        {...{ className, label }}
      />
    ) : (
      <MaterialSwitch
        {...props}
        {...{ checked, id, className, color }}
        onChange={onClickWrapper(id, onChange)}
        {...input}
      />
    );

  render() {
    const { className, name, value, id, onChange, label, color } = this.props;

    const customProps = { className, id, onChange, label, color };

    return name ? (
      <Field
        {...{ className, name, onChange, value }}
        component={Switch.renderSwitch}
        props={customProps}
      />
    ) : (
      Switch.renderSwitch(customProps)
    );
  }
}

Switch.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
};

export default Switch;
